// ** React Imports
import { Box, Typography } from '@mui/material';
import Link from 'next/link';
import { useRouter } from 'next/router';

const PleaseLogin = () => {
  const router = useRouter();

  return (
    <Box className="content-center">
      <Box
        sx={{
          p: 5,
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          textAlign: 'center',
        }}
      >
        <Typography sx={{ mb: 2.5 }} variant="h1">
          401
        </Typography>
        <Typography
          sx={{
            mb: 2.5,
            letterSpacing: '0.18px',
            fontSize: '1.5rem !important',
          }}
          variant="h5"
        >
          Please Login
        </Typography>
        <Link
          href={'/login'}
        >
          <Typography
            sx={{
              mb: 2.5,
              letterSpacing: '0.18px',
              fontSize: '1.5rem !important',
              backgroundColor: 'primary.main',
              color: 'white',
              borderRadius: '4px',
              padding: '12px 24px',
              textAlign: 'center',
              display: 'inline-block',
              '&:hover': {
                backgroundColor: 'primary.dark',
              },
            }}
            variant="h5"
          >
            Login
          </Typography>
        </Link>
      </Box>
    </Box>
  );
};

export default PleaseLogin;
